<template>
  <div class="w-full">
    <div
      :ref="(elementRef) => setRef(elementRef as HTMLDivElement)"
      class="search-bar-wrapper"
      :class="{
        inactive: !isFull,
        active: isFull,
      }">
      <div class="search-bar transition-all">
        <div class="search-bar-form-wrap">
          <FormKit type="form" :actions="false" autocomplete="off" class="search-bar-form" @submit="handleSearchClick">
            <FormKit
              :id="searchInputName"
              ref="searchInput"
              v-model="searchQuery"
              :name="searchInputName"
              type="text"
              :placeholder="searchbarPlaceholder"
              :maxlength="maxSearchTextLength"
              class="w-full text-base"
              aria-autocomplete="none"
              @focus="handleSearchOpenState(true)"
              @blur="handleSearchBlur" />
            <button>
              <i class="fas fa-magnifying-glass" />
            </button>
          </FormKit>

          <SearchSuggestions v-show="isSearchOpen" :search-query="searchQuery" :is-open="isSearchOpen" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useSearchBar } from '~/composables/useSearchBar'
import SearchSuggestions from '@/components/Search/SearchSuggestions.vue'

const props = defineProps<{
  mini?: boolean
}>()
const { isWhitelabel } = useTheme()
const isFull = ref(!props.mini)

const toggleSearchbar = () => {
  isFull.value = !isFull.value
}

const { t } = useLang()
const {
  searchQuery,
  handleSubmit,
  isSearchOpen,
  handleSearchOpenState,
  setRef,
  maxSearchTextLength,
  handleSearchBlur,
} = useSearchBar()

const handleSearchClick = () => {
  if (isWhitelabel && !isSearchOpen.value) {
    return toggleSearchbar()
  }

  return handleSubmit()
}

const searchInput = ref<HTMLElement | null>(null)
const searchInputName = 'search-input'
const searchbarPlaceholder = computed(() => t('header.search-bar-placeholder'))

defineExpose({
  searchInput,
})
</script>

<style lang="postcss" scoped>
.search-bar-wrapper {
  @apply flex flex-1 relative px-4 py-2 lg:alt:pl-0 lg:alt:py-3;

  &.active .search-bar {
    @apply w-full;
  }

  &.inactive .search-bar {
    @apply w-0;
  }

  .search-bar {
    @apply flex lg:ml-6 w-full alt:ml-0;

    .search-bar-form-wrap {
      @apply flex items-center relative ml-auto max-w-[700px] w-full;

      .search-bar-form {
        @apply flex items-center relative ml-auto w-full;
      }

      :deep(.formkit-form) {
        @apply w-full;

        .formkit-outer {
          @apply mb-0;

          .formkit-wrapper {
            @apply drop-shadow-sm;
            .formkit-inner {
              @apply rounded-[6px] border transition-[border];
              @apply border-neutral6 dark:border-dmGray1 hover:border-neutral5 focus-within:border-brand-primary hover:focus-within:border-brand-primary;
              @apply shadow-none focus-within:shadow-none;

              input {
                @apply pl-[1rem] pr-[3rem] h-[2.5rem] text-base font-normal;
              }
            }
          }
        }

        button {
          @apply absolute flex items-center right-0 top-0 h-full px-4 py-0 text-gray5 dark:text-dmText1;
        }
      }
    }
  }
}

.wl {
  .search-bar-wrapper {
    @apply justify-end lg:pr-0;

    :deep(.formkit-form) {
      @apply overflow-hidden;
    }

    button i {
      @apply text-brand-primary;
    }
  }
}
</style>
